// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var QuotingType;
(function (QuotingType) {
    QuotingType[QuotingType["None"] = -1] = "None";
    QuotingType[QuotingType["TickCost_TickSize"] = 0] = "TickCost_TickSize";
    QuotingType[QuotingType["LotSize"] = 1] = "LotSize";
})(QuotingType || (QuotingType = {}));
